<script lang="ts">
  export let handleConfirmEvent!: any;

  const handleConfirm = (): void => {
    handleConfirmEvent();
  };
</script>

<div class="h-auto p-6 bg-white m-auto max-w-4xl">
  <div class="mb-6">
    <div class="container flex justify-between">
      <h1 class="text-2xl font-bold text-gray-700">回線モデムの返却について</h1>
    </div>
  </div>
  <div class="shadow rounded bg-white border-t-2 border-green-400">
    <div class="flex-1 m-10">
      <div class="inline-flex justify-items-center items-center min-w-full">
        <div class="mb:font-sm w-full">
          <p>
            回線を利用の際に使用している専用モデムについては、<span class="warning">解約月翌月20日必着</span
            >でご返却いただく必要があります。
          </p>
          <p>
            期日までの返却ができない場合、<span>弁済費(8,000円)</span>が必要になりますのでご注意ください
          </p>
        </div>
      </div>
    </div>
    <div class="flex flex-col justify-items-center items-center mt-5">
      <div class="shadow rounded bg-yellow-50 w-11/12 content-center p-2">
        <div class="flex-1 m-4">
          <div class="inline-flex justify-items-center items-center min-w-full">
            <div class="mb:font-sm w-full">
              <p>■返却が必要な機器</p>
              <p class="ml-4">モデム、ACアダプタ、スタンド</p>
              <p class="ml-4">
                <span class="warning">※ DASAN製モデム(H-320 / H-330 / DMT-100等) は返却不要です</span>
              </p>
              <p>■返却先</p>
              <p>・住所：〒259-1304 神奈川県秦野市堀山下320 ロジスティード南関東株式会社</p>
              <p>・宛名： U-NEXT光01サービスアルテリアネットワークス配送センター宛て</p>
              <p>※着払いでお送りください</p>
              <p>※手続きを進めるまえにお書留めください</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col justify-items-center items-center">
      <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
        <button class="button-primary md:ml-5 mb-5" on:click={handleConfirm}> 確認 </button>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
  p {
    @apply tracking-normal mb-1;
  }
  p > span.warning {
    @apply font-semibold text-red-400;
  }

  .button-primary {
    @apply bg-green-400 rounded hover:bg-green-500 text-sm font-semibold text-white focus:outline-none px-10 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default;
  }
</style>
